import { colors } from '../../../styles/theme';
import { scrollableListZoneSx } from '../UserLotListsPanel/UserLotListsPanel.styles';

/** Panel Historial: mismos tokens que Registros (fondo, borde, card). */
export const historyPaperSx = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  height: '100%',
  minHeight: '100%',
  bgcolor: colors.backgroundSurface,
  backgroundImage: 'none',
  color: colors.textPrimary,
  boxShadow: '0 18px 45px rgba(15,23,42,0.55)',
  border: `1px solid ${colors.border}`,
  borderRadius: { xs: 0, sm: '16px' },
};

export const historyHeaderZoneSx = { bgcolor: colors.backgroundSurface };

/** Buscador + totales, separados de la lista por una línea (como Registros). */
export const historyToolbarZoneSx = {
  flexShrink: 0,
  bgcolor: colors.backgroundSurface,
  borderBottom: '1px solid rgba(255,255,255,0.06)',
};

export const historyToolbarBoxSx = { px: 2.5, pt: 2, pb: 1.5 };

/** Zona con scroll de la lista. El fade se suma con `getScrollEdgeFadeSx`. */
export const historyScrollZoneSx = {
  ...scrollableListZoneSx,
  flex: 1,
  bgcolor: colors.backgroundSurface,
  px: 2.5,
  mr: 0.5,
  // Columna flex: el estado vacío ocupa todo el alto y queda centrado.
  display: 'flex',
  flexDirection: 'column',
};

/** Grupos de día (Hoy, Ayer…) y cards dentro de cada grupo. */
export const historyGroupsStackSx = { display: 'flex', flexDirection: 'column', gap: 2, flexShrink: 0 };
export const historyCardsStackSx = { display: 'flex', flexDirection: 'column', gap: 1 };

/** Misma card que Registros (`RegistrosLotCard`). */
export const historyCardSx = {
  borderRadius: '8px',
  border: 'none',
  backgroundColor: colors.backgroundDark,
  overflow: 'hidden',
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',
  '&:hover': { bgcolor: '#2a2a2a' },
};

export const historyCardHeaderSx = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  px: '12px',
  py: '10px',
};

/** Columna del ⋮ a la altura del título (18 px), como las otras cards. */
export const historyCardActionsSx = { flexShrink: 0, height: 18, display: 'flex', alignItems: 'center' };

/** Skeleton: mismos grises que Registros. */
export const historySkeletonPrimarySx = { bgcolor: '#383838', borderRadius: '4px' };
export const historySkeletonMutedSx = { bgcolor: '#2E2E2E', borderRadius: '4px' };
export const historySkeletonFieldSx = { bgcolor: '#383838', borderRadius: '8px' };
